<template>
  <v-app>
    <app-drawer
      v-if="isAuthenticated"
      ref="drawer"
      class="admin_drawer"
      @drawer:collapsed="mini = !mini"
    />
    <app-toolbar
      v-if="isAuthenticated"
      class="admin_toolbar"
      extended
      @side-icon-click="handleDrawerVisiable"
    />
    <!-- Page Wrapper -->
    <v-main class="grey lighten-3">
      <router-view />
    </v-main>
    <cookie-gdpr />
    <!-- App Footer -->
    <v-footer app bottom fixed padless height="40px">
      <v-col class="text-right" cols="12">
        <span
          >Themis-app.ch Copyright &copy; {{ new Date().getFullYear() }}</span
        >
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import AppDrawer from "@/components/AppDrawer"
import AppToolbar from "@/components/AppToolbar"
import { mapGetters } from "vuex"
import CookieGdpr from "@/components/CookieGdpr"

export default {
  name: "LayoutDefault",
  components: {
    CookieGdpr,
    AppDrawer,
    AppToolbar,
  },

  data() {
    return {
      mini: false,
      showDrawer: true,
    }
  },
  methods: {
    handleDrawerVisiable() {
      console.log("DONE")
      this.$refs.drawer.toggleDrawer()
    },
  },
  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
  },
}
</script>
